import React from 'react';
import { Tree, Icon, Input } from 'antd';
import * as  eChartCommon from '../echart/eChartCommon';
import { genAction, proxy } from '../../helpers/util';
const Search = Input.Search;
const TreeNode = Tree.TreeNode;


export class DimensionNavTreeControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      billnum: props.viewModel.getParams().billNo || "ct_costdetail",
      searchValue: '',
      autoExpandParent: true,
      treeData: {},
      firstQueryDone: false
    };
    this.expandedKeys = [];
    this.selectedKeys = [];
    this.bSetDefaultOpenEle = false;
    this.TreeHeadKey = "all";
    this.dimensionId = undefined;
    this.defaultOpenEle = undefined;
  }

  doProxy(url, method, params, callback, noUniform) {
    const config = { url: url, method: method, params: params };
    if (noUniform) {
      config.options = { uniform: false };
    }
    proxy(config)
      .then(json => {
        callback(json);
      });
  }

  getData() {
    let self = this;
    if (this.dimensionId) {
      let callback = (json) => {
        if (json.code === 200) {
          if (json.data && json.data.recordList && json.data.recordList.length > 0) {
            self.bSetDefaultOpenEle = true;
            self.setState({ treeData: json.data });
          }
          else {
            self.setState({ treeData: [] });
            this.filterViewModel.execute('navClick', {});
          }
        }
      }
      self.doProxy('/report/list', 'POST', { billnum: this.state.billnum, condition: self.state.condition, dimensionId: this.dimensionId }, callback);
    }
  }
  getTitle(navKey, title) {
    let searchValue = this.state.searchValue

    if (searchValue != "") {
      let index = title.indexOf(searchValue);
      let beforeStr = title.substr(0, index);
      let afterStr = title.substr(index + searchValue.length);
      if (index > -1) {
        return (
          <span>
            {beforeStr}
            <span style={{ color: '#f50' }}>{searchValue}</span>
            {afterStr}
          </span>
        )
      }
      else {
        if (this.expandedKeys.indexOf(navKey) >= 0)
          return <span>{title}</span>;
        else
          return undefined;
      }
    }
    return <span>{title}</span>;
  }
  getTreeNodes(recordList, parentFilter, parentKey, parentKeys) {
    let self = this;
    if (parentKey == this.TreeHeadKey) {
      this.defaultEle = undefined;
    }
    let treeNodes;
    if (recordList && recordList.length > 0) {
      treeNodes = [];
      recordList.forEach(ele => {
        let filter = _.cloneDeep(parentFilter);
        ele.field && ele.field.forEach((item, index) => {
          if (ele.caption[index] != "null")
            filter[item] = ele.caption[index];
        });
        if (!ele.navKey) {
          ele.navKey = "navKey_" + Math.random().toString().replace(".", "");
          ele.parentKey = parentKey;
          ele.parentKeys = parentKeys;
          ele.joinedCaption = ele.caption && ele.caption.join("_");
          ele.joinedCaption = ele.joinedCaption || "空分组项";
          ele.filter = filter;
        }
        if (ele.joinedCaption) {
          if (!self.defaultEle) {
            self.defaultEle = ele;
          }
          else if (ele.parentKey == self.defaultEle.navKey) {
            self.defaultEle = ele;
          }
          let title = this.getTitle(ele.navKey, ele.joinedCaption);
          if (title) {
            let childrenNodes = undefined;
            ele.bLeaf = true;
            if (ele.children && ele.children.length > 0) {
              ele.bLeaf = false;
              childrenNodes = this.getTreeNodes(ele.children, filter, ele.navKey, parentKeys + "," + ele.navKey);
            }
            treeNodes.push(<TreeNode
              title={title}
              key={ele.navKey}
              filter={filter}
              ele={ele}
            >
              {childrenNodes}
            </TreeNode >);
          }
        }
        else {
          eChartCommon.LogChartInfo("维度导航树 查询返回的数据存在空树节点。行数据   ", JSON.stringify(ele), 999);
        }
        // treeNodes.push(<TreeNode {...node} > {childrenNodes}</TreeNode >);
      });
    }
    return treeNodes;

  }
  onSelect(selectedKeys, e) {

    let bExecute = true;
    if (this.props.viewModel.hasEvent("DimensionNavTreeClicked")) {
      bExecute = this.props.viewModel.execute('DimensionNavTreeClicked', e.node.props.ele);
    }
    if (bExecute) {
      eChartCommon.LogChartInfo("维度导航树 选择点的过滤项目 ", JSON.stringify(e.node.props.filter), 901);
      this.selectedKeys = selectedKeys;
      this.forceUpdate();
      this.filterViewModel.execute('navClick', e.node && e.node.props.filter || {});
    }
    return bExecute;
  }
  onExpand = (expandedKeys, e) => {
    // this.setState({ expandedKeys: expandedKeys });
    this.expandedKeys = expandedKeys;
    if (e) { //通过点击＋或者-触发
      this.setState({ autoExpandParent: false });
    } else { //通过搜索触发
      this.setState({ autoExpandParent: true });
    }
  }

  getExpandedKeys(recordList, value, expandedKeys) {
    if (recordList && recordList.length > 0) {
      recordList.forEach(ele => {
        if (ele.joinedCaption.indexOf(value) > -1) {
          if (expandedKeys.indexOf(ele.parentKey) == -1)
            expandedKeys.push(ele.parentKey);
        }
        if (ele.children && ele.children.length > 0) {
          this.getExpandedKeys(ele.children, value, expandedKeys);
        }
      })
    }
  }

  onChange = (e) => {
    const value = e.target.value;
    let expandedKeys = [];
    if (value != "") {
      this.getExpandedKeys(this.state.treeData.recordList, value, expandedKeys)
    }
    this.expandedKeys = expandedKeys;
    this.setState({
      searchValue: value,
      autoExpandParent: true,
    });
  }

  render() {

    let treeNodes = this.getTreeNodes(this.state.treeData.recordList, {}, this.TreeHeadKey, this.TreeHeadKey);

    if (this.bSetDefaultOpenEle == true) {
      if (this.defaultEle) {
        this.expandedKeys = this.defaultEle.parentKeys.split(",") || [];
        this.selectedKeys = [this.defaultEle.navKey];
        this.filterViewModel.execute('navClick', this.defaultEle.filter || {})
      }
      this.bSetDefaultOpenEle = false;
    }
    return (
      <div  >
        <Search
          style={{ marginBottom: 5 }}
          placeholder="Search"
          onChange={this.onChange}
        />
        <Tree
          onSelect={(selectedKeys, e) => this.onSelect(selectedKeys, e)}
          onExpand={this.onExpand}
          expandedKeys={this.expandedKeys}
          autoExpandParent={this.state.autoExpandParent}
          // autoExpandParent={true}
          selectedKeys={this.selectedKeys}
        >
          <TreeNode title="全部类别" key={this.TreeHeadKey} >
            {treeNodes}
          </TreeNode >
        </Tree>
      </div>
    )
  }
  onFilterClick = (params) => {
    if (!params.bFromNav && this.state.firstQueryDone) {
      this.state.condition = params.condition;
      // this.state.condition = { 'commonVOs': [{ 'itemName': 'schemeName', 'value1': '默认方案' }, { 'itemName': 'isDefault', 'value1': false }, { 'value1': 21191, 'itemName': 'product_cName' }, { 'value1': 831590476714240, 'itemName': 'accGroupID_name' }], 'filtersId': '103551687', 'solutionId': 12714352 };
      this.getData();
    }
  };
  componentDidMount() {
    let self = this;
    let viewModel = self.props.viewModel;
    // if (this.props.model)
    //   this.props.model.addListener(this);

    viewModel.on("filterClick", self.onFilterClick);
    viewModel.on('firstQueryDone', (params) => {
      self.state.firstQueryDone = params;
    });

    // viewModel.on('refreshEChartConfig', (params) => {
    //   if (params.dimensionId && params.dimensionId !== this.dimensionId) {
    //     this.dimensionId = params.dimensionId;
    //     if (this.state.firstQueryDone)
    //       this.getData();
    //   }
    // });

    viewModel.on('dimensionChanged', (params) => {
      self.dimensionId = params.dimensionId;
      if (params.dimensionId) {//&& params.dimensionId !== this.dimensionId
        if (self.state.firstQueryDone)
          self.getData();
      }
    });
    this.filterViewModel = viewModel.getCache('FilterViewModel');
  }
  componentDidUpdate() {
    // if (this.props.model)
    //   this.props.model.addListener(this);
  }
  componentWillReceiveProps(nextProps) {

  }
  componentWillUnmount() {

  }
};
export default DimensionNavTreeControl



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/DimensionNavTree.jsx